function adjustVideoSpeed() {
  var videos = Array.from(document.querySelectorAll('video[data-speed]'));
  videos.forEach(function(video) {
    video.playbackRate = Number(video.getAttribute('data-speed')) || 1;
  });
}

document.addEventListener("turbolinks:load", adjustVideoSpeed);